module.exports = "data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAABQAwCdASqIAAUAPpFIn0ulpCKho4gAsBIJaQDTJAn+ThSggAD+77v3lMW2EO4AAAA="